import { Box, SxProps, Theme } from '@mui/material';

import { Icon } from '../Icon';

import { spinnerStyleState } from './styleState';
import { SpinnerPositionProps, SpinnerSizeProps } from './types';

export interface SpinnerProps {
  size?: SpinnerSizeProps;
  position?: SpinnerPositionProps;
  sx?: SxProps<Theme>;
  iconSize?: number;
}

const rotateKeyframes: SxProps<Theme> = {
  '@keyframes rotate': {
    '0%': {
      transform: 'rotate(0)',
    },
    '100%': {
      transform: 'rotate(1turn)',
    },
  },
};

export const Spinner = ({ size = 's', position = 'initial', iconSize = 100, sx }: SpinnerProps) => {
  return (
    <Box
      sx={
        {
          svg: {
            ...spinnerStyleState.size[size],
            ...spinnerStyleState.position[position],
            ...rotateKeyframes,
            animation: 'rotate 1s linear infinite',
          },
          ...sx,
        } as SxProps<Theme>
      }
    >
      <Icon type="loader" size={iconSize} />
    </Box>
  );
};
